import { render } from "./PermissionErrorPage.vue?vue&type=template&id=1655165a"
import script from "./PermissionErrorPage.vue?vue&type=script&lang=js"
export * from "./PermissionErrorPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__